import type engageEn from "./engage.en";

const engageAr: Record<keyof typeof engageEn, string> = {
  "cod.awaiting": "بانتظار تأكيد العميل لطلب الدفع عند الاستلام. التجهيز معلّق حتى يؤكده، أو تؤكده أنت بعد الاتصال به.",
  "cod.mark_confirmed": "تحديد كمؤكَّد",
  "cod.confirmed_toast": "تم تأكيد الطلب. يمكن بدء التجهيز.",
  "gift.title": "رسالة الهدية",
  "gift.no_message": "هذا الطلب هدية (دون رسالة).",
  "ret.title": "المرتجعات",
  "ret.description": "طلبات الإرجاع والاستبدال التي يقدّمها العملاء من صفحة طلبهم.",
  "ret.all": "كل المرتجعات",
  "ret.manage": "إدارة",
  "ret.modal_title": "الإرجاع {name}",
  "ret.approve": "موافقة",
  "ret.decline": "رفض",
  "ret.receive": "تحديد كمستلَم",
  "ret.close": "إغلاق الإرجاع",
  "ret.customer_note": "ملاحظة العميل",
  "ret.instructions": "التعليمات المرسلة",
  "ret.decline_reason": "السبب المذكور",
  "ret.message": "رسالة إلى العميل",
  "ret.message_hint": "مع الموافقة: كيف يعيد المنتجات. مع الرفض: السبب. تُرسل إليه بالبريد.",
  "ret.refund_hint": "استرد قيمة المنتجات المرتجعة من الطلب، ثم أغلق الإرجاع.",
  "ret.refund_link": "استرداد",
  "ret.status.requested": "مطلوب",
  "ret.status.approved": "موافق عليه",
  "ret.status.declined": "مرفوض",
  "ret.status.received": "مستلَم",
  "ret.status.closed": "مغلق",
  "ret.status.cancelled": "ملغى",
  "ret.kind.refund": "استرداد",
  "ret.kind.exchange": "استبدال",
  "ret.reason.size_too_small": "صغير جداً",
  "ret.reason.size_too_large": "كبير جداً",
  "ret.reason.not_as_described": "غير مطابق للوصف",
  "ret.reason.damaged": "وصل تالفاً",
  "ret.reason.wrong_item": "أُرسل منتج خاطئ",
  "ret.reason.changed_mind": "غيّر رأيه",
  "ret.reason.other": "أخرى",
  "ret.empty": "لا توجد طلبات إرجاع",
  "ret.empty_body": "عندما يطلب العملاء إرجاع منتجات من صفحة طلبهم تظهر الطلبات هنا.",
  "ret.col.return": "الإرجاع",
  "ret.col.order": "الطلب",
  "ret.col.items": "المنتجات",
  "ret.col.status": "الحالة",
  "ret.col.date": "تاريخ الطلب",
  "rev.title": "التقييمات",
  "rev.description": "متوسط {average}★ من {published} تقييم منشور.",
  "rev.pending": "بالانتظار",
  "rev.published": "منشورة",
  "rev.rejected": "مرفوضة",
  "rev.all": "الكل",
  "rev.rating": "التقييم",
  "rev.any_rating": "أي تقييم",
  "rev.search": "ابحث في التقييمات أو المنتجات",
  "rev.selected": "{n} محدد",
  "rev.publish": "نشر",
  "rev.reject": "رفض",
  "rev.delete_title": "حذف هذه التقييمات؟",
  "rev.delete_body": "تُحذف نهائياً ويُحدّث تقييم المنتج.",
  "rev.bulk_done": "تم تحديث {n} تقييم.",
  "rev.deleted": "تم حذف التقييم.",
  "rev.empty_pending": "لا توجد تقييمات بالانتظار",
  "rev.empty": "لا توجد تقييمات هنا",
  "rev.empty_body": "تظهر هنا التقييمات التي يكتبها العملاء في صفحات المنتجات ومن رسائل طلب التقييم.",
  "rev.select": "تحديد التقييم",
  "rev.verified": "مشترٍ موثّق",
  "rev.status.pending": "بالانتظار",
  "rev.status.published": "منشور",
  "rev.status.rejected": "مرفوض",
  "rev.your_reply": "ردك",
  "rev.helpful": "وجده {n} مفيداً",
  "rev.reply": "رد",
  "rev.reply_title": "الرد على {name}",
  "rev.post_reply": "نشر الرد",
  "rev.reply_hint": "يظهر ردك أسفل التقييم في صفحة المنتج. اتركه فارغاً لحذفه.",
  "ins.wish_title": "إحصاءات قائمة الأمنيات",
  "ins.wish_description": "حفظ {n} عميل منتجات.",
  "ins.wish_empty": "لا توجد منتجات محفوظة بعد",
  "ins.wish_empty_body": "عندما يحفظ العملاء المسجّلون منتجات تظهر الأكثر طلباً هنا.",
  "ins.product": "المنتج",
  "ins.saves": "مرات الحفظ",
  "ins.in_stock": "المتوفر",
  "ins.last_saved": "آخر حفظ",
  "ins.sold_out": "نفد",
  "ins.stock_title": "طلبات التنبيه بالتوفر",
  "ins.stock_description": "منتجات نفدت وطلب العملاء إخبارهم بها. أعد توفير الأكثر طلباً أولاً.",
  "ins.stock_empty": "لا توجد طلبات بعد",
  "ins.stock_empty_body": "عندما يطلب العملاء إخبارهم بمنتج نفد يظهر هنا.",
  "ins.waiting": "بالانتظار",
  "ins.notified": "تم إخبارهم",
  "ins.latest": "الأحدث",
};

export default engageAr;
